export default "__VITE_ASSET__C1Jb3Gdt__"